/**
 * Which Endpoint Security pages have been switched to their pinned Atlas version.
 *
 * A page is listed here only after its preview (/endpoint-security/preview/<page>)
 * has been compared with the module's own page on sandbox org 3 and signed off by
 * the product owner. Until then the module's route keeps rendering its own page,
 * so nothing changes for anyone by adding a preview. See Phase 4 of
 * Context/endpoint-security-atlas-inheritance-plan.md.
 *
 * Page ids: 'alerts' (more join as the Security, Adoption and Policy pages are
 * wired). AI Tools, Users, Overview, Log Explorer, DLP Analytics, Coverage and
 * Devices stay the module's own and are never switched.
 */
export const SIGNED_OFF = new Set([]);

export const isSwitched = (page) => SIGNED_OFF.has(page);
